const Types = {
  LIST_IVR_FUNCTIONS: '@ivrFunctions/LIST_IVR_FUNCTIONS',
  LIST_IVR_FUNCTIONS_SUCCESS: '@ivrFunctions/LIST_IVR_FUNCTIONS_SUCCESS',
};

export default Types;
